import { useTranslation } from 'react-i18next'
import { Button, Press } from '@dorixona/ui'
import { Sheet } from '../../ui/Sheet'
import { Icon } from '../../ui/Icon'
import { FILTERS, type StoreFilter } from './model'

export interface StoresFilterSheetProps {
  opened: boolean
  filter: StoreFilter
  /** Сколько аптек нашлось; пока список грузится — неизвестно. */
  found: number | undefined
  onChange: (filter: StoreFilter) => void
  onClose: () => void
}

/** Фильтры аптек — та же шторка, что в каталоге. Отбор применяется сразу. */
export function StoresFilterSheet({
  opened,
  filter,
  found,
  onChange,
  onClose,
}: StoresFilterSheetProps) {
  const { t } = useTranslation(['stores', 'catalog', 'common'])

  return (
    <Sheet opened={opened} label={t('catalog:filters')} onClose={onClose}>
      <div className="fsheet">
        <div className="fhead">
          <h2>{t('catalog:filters')}</h2>
          <Press
            squish="icon"
            className="fclose"
            aria-label={t('common:actions.close')}
            onPress={onClose}
          >
            <Icon name="i-x" size={18} />
          </Press>
        </div>

        <div className="fgroup" role="group" aria-label={t('stores:mode')}>
          <div className="fl">{t('stores:mode')}</div>
          <div className="fopts">
            {FILTERS.map((value) => (
              <Press
                key={value}
                squish="chip"
                className={filter === value ? 'fopt on' : 'fopt'}
                aria-pressed={filter === value}
                onPress={() => {
                  onChange(value)
                }}
              >
                {t(`stores:filters.${value}`)}
              </Press>
            ))}
          </div>
        </div>

        <div className="ffoot">
          <Button onPress={onClose}>
            {found === undefined ? t('stores:show') : t('stores:showCount', { n: found })}
          </Button>
        </div>
      </div>
    </Sheet>
  )
}
